import React from "react";
import Home from "./Home";
import useCoreApps from "../../../hooks/useCoreApps";
import useMyApps from "../../../hooks/useMyApps";

/** A wrapper for the Home component taking care of what tiles to display */
function HomeContainer() {
  const {myApps, loading: myAppsLoading} = useMyApps();
  const {coreApps, loading: coreAppsLoading} = useCoreApps();

  return (
    <Home
      myGroupApps={myApps}
      coreApps={coreApps}
      myGroupAppsLoading={myAppsLoading}
      coreAppTilesLoading={coreAppsLoading}
    />
  );
}

export default HomeContainer;
